import { render, staticRenderFns } from "./CompletionWidget.vue?vue&type=template&id=cb953776&scoped=true&"
import script from "./CompletionWidget.vue?vue&type=script&lang=js&"
export * from "./CompletionWidget.vue?vue&type=script&lang=js&"
import style0 from "./CompletionWidget.vue?vue&type=style&index=0&id=cb953776&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb953776",
  null
  
)

/* custom blocks */
import block0 from "./CompletionWidget.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VBtn,VCard,VProgressCircular})
